module.exports = __webpack_public_path__ + "img/selsam.341042a3.png";